import { PiArmchair, PiForkKnife, PiTelevisionSimple } from "react-icons/pi";

// Что входит в тариф помимо багажа (connectors: segment.included_services, сейчас только flydubai):
// питание, выбор места, развлечения на борту. Нет поля — ничего не рисуем.
const ICONS = {
  meal: PiForkKnife,
  seat: PiArmchair,
  entertainment: PiTelevisionSimple,
};

const IncludedServicesIcons = ({ segment, language }) => {
  const shown = {};
  (segment?.included_services || []).forEach(service => {
    if (ICONS[service.kind] && !shown[service.kind]) {
      shown[service.kind] = service.name?.[language] || service.name?.en || service.code;
    }
  });

  return Object.keys(shown).map(kind => {
    const Icon = ICONS[kind];
    return (
      <div key={kind} title={shown[kind]}>
        <Icon />
      </div>
    );
  });
};

export default IncludedServicesIcons;
